import { Toaster } from "react-hot-toast";
import Layout from "../shared/Layout";
import { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { API_URL, baseurl } from "../../_config";

const PassOrderList = () => {
    const [passOrdersList, setPassOrdersList] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);

    const fetchPassOrderslist = async () => {
        try {
            const response = await axios.get(`${baseurl}${API_URL.getPassOrderslist}`);
            if (response?.data.status === true) {
                setPassOrdersList(response?.data?.data)
            }
        } catch {
            return null;
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPassOrderslist();
    }, []);


    useEffect(() => {
        if (searchTerm) {
            const filtered = passOrdersList?.filter(item =>
                (item.name && item.name.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.customerId && item.customerId.toString().includes(searchTerm.toString()))
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(passOrdersList);
        }
    }, [searchTerm, passOrdersList]);


    const columns = [
        {
            name: 'S.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '60px',
        },
        {
            name: 'Pass',
            selector: row => (
                <>
                    <img src={row?.imagePath} alt="" />
                </>
            ),
            sortable: true,
            minWidth: '150px'
        },
        {
            name: 'PassType',
            selector: row => row.name,
            sortable: true,
            minWidth: '100px'
        },
        {
            name: 'CustomerId',
            selector: row => (
                <div className="" >
                    {/* <h6>{row.captainEmail}</h6> */}
                    <span>{row?.customerId}</span>
                </div>
            ),
            sortable: true,
            minWidth: '150px'
        },
        {
            name: 'Quantity',
            selector: row => row.quantity,
            sortable: false

        }
    ];

    return (
        <Layout>
            <Toaster position="top-right" />
            <div className="right-content-section">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading">
                        <h4 className="mb-0">Pass Order List</h4>
                    </div>
                    <div className="d-md-flex align-items-center justify-content-end">
                        <div className="search-container ">
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>

                <div className="datatable mt-4">
                    <DataTable
                        columns={columns}
                        data={filteredData || []}
                        progressPending={loading}
                        progressComponent={<p>Loading...</p>}
                        pagination
                        highlightOnHover
                    />
                </div>
            </div>
        </Layout>
    )
}

export default PassOrderList;